/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/motherhood/components/standalone/CoverBox/theme';

export const CoverBoxTheme = theme;
